/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15 7.694L8 1 1 7.694h2.277V14h2.696v-3.705h4.054V14h2.696V7.694H15\"/></svg>\n";
//# sourceMappingURL=home-page.svg.js.map